module.exports = __webpack_public_path__ + "static/media/chat-icon-notification.70357c0f.svg";